 <template>
  <Layout>
    <PageHeader :title="title" :items="items" v-show="false"/>
    <div> 
      <div class="row">
        <keep-alive>
          <div>
            <b-tabs 
              v-model="tabIndex" 
              align="left"
              active-nav-item-class="text-primary border-0"
              nav-class="border-gray-300 d-print-none w-50 role-tabs"
              class="sub-tabs"
              nav-wrapper-class="d-flex justify-content-end pe-5 me-5"
            >
              <template #tabs-start>
                <div v-if="pills" style="position: absolute; left: 10px; top:0" class="back d-flex gap-2 bg-white p-1 rounded shadow-xs">
                  <b-button 
                    v-bind:key="key" 
                    v-for="(pill, key) in pills()" 
                    :pressed="true" 
                    tag="div" 
                    size="lg"
                    :class="`
                      px-5
                      py-1
                      ${pill.active ? 
                      'bg-primary text-white' : 
                      'bg-white border-0'}`" 
                    variant="light" 
                    v-bind="pill" 
                    @click="pill.onClick">
                    {{pill.label}}
                  </b-button>
                </div>
              </template>
              <template #tabs-end>
                <div class="d-flex"
                  style="position: absolute; right: 0"
                >
                  <b-button
                    class="btn btn-success waves-effect waves-light me-1 ms-2 d-flex"
                    @click="handlePrint"
                    >
                    <i class="bx bx-download" style="font-size: 16px; color: white"></i>
                    <span class="text-white">
                      Unduh
                    </span>
                  </b-button>
                </div>
              </template>
              <template 
                v-for="(tab, index) in tabs"
              >
                <b-tab :key="index" :title="tab.title">
                  <model-show
                    :loading="loading"
                    v-bind="$props"
                    :value="model"
                    :model-mapped="tab.modelMapped"
                    @back-click="handleBack"
                    @edit-click="handleEdit"
                    @delete-click="handleDelete"
                    @print-click="handlePrint"
                  ></model-show>
                </b-tab>
              </template>
            </b-tabs>
          </div>
        </keep-alive>        
      </div>
    </div>
    <modal-resume-export
      @update:checked="checked = $event"
      :items="exportables"
    ></modal-resume-export>
    <!-- <b-button
      v-b-modal.export-modal
      class="btn btn-success waves-effect waves-light me-1 ms-2"
      ><i class="fa fa-print"></i
    >Print</b-button> -->
  </Layout>
</template>

<script>
import ModelTabShow from "../models/show-tab.vue";
import ModelShow from '@/components/models/show'

import Row from "@/components/models/show/custom-row";
import ModalResumeExport from "@/components/modals/modal-resume-export.vue"

export default {
  extends: ModelTabShow,
  components: {
    ModelShow,
    ModalResumeExport
  },
  page: {
    title: "Detail Sale Notes",
  },
  props: {
    cardTitle: {
      default() {
        return undefined;
      },
    },
    resourceRoute: { default: "sale_notes.resume" },
    modelVariable: { default: "resume" },
    denyDelete: { type: Boolean, default: true },
    denyBack: { type: Boolean, default: true },
    // printable: { type: Boolean, default: true },
    denyEdit: { type: Boolean, default: true },
    columns: {
      type: Object,
      default() {
        return {
          [this.modelVariable || "model"]: [
            {
              key: "key",
              label: this.$t("models.key"),
              component: Row,
            },
          ],
        };
      },
    },
    cardAttrs: {
      default() {
        return {
          style: "background: transparent; box-shadow: none; border: none;",
        };
      },
    },
    tableProps: {
      default(){
        return {
          "tbody-tr-class": "main-table",
        }
      }
    },
  },
  watch: {
    model: function (val, oldVal) {
      if (!this.lodash.isEqual(val, oldVal)) {
        if (val.ticket.customer_type !== "brs") this.denyEdit = true;
      }
    },
    'tabIndex': {
      handler: function (val){
        if(val){
          this.exportables = this.tabs[this.tabIndex]?.modelMapped
                              ?.filter((item) => item.printable)
                              .filter((item, index, self) => self.findIndex((t) => t.key === item.key) === index)
                              .map((item) => ({name: item.key}))
        }
      },
      immediate: true
    },
    'loading': {
      handler: function (val){
        if(!val){
          this.exportables = this.tabs[this.tabIndex]?.modelMapped
                              ?.filter((item) => item.printable)
                              .filter((item, index, self) => self.findIndex((t) => t.key === item.key) === index)
                              .map((item) => ({name: item.key}))
        }
      },
      immediate: true
    }
  },
  data() {
    return {
      title: this.lodash.startCase(this.$t("sale_notes.plural")),
      discountsPartnerVisible: false,
      exportables: [],
      tabIndex: 0,
    };
  },
  mounted() {
    this.fetchModel();
  },
  computed: {
    items() {
      return [
        {
          text: this.lodash.startCase(this.$t("sale_notes.plural")),
          href: "/sale_notes",
        },
        {
          text:
            this.model && this.model.id
              ? this.model["name"]
              : this.$route.params.key,
          href: `/sale_notes/${this.$route.params.key}`,
          active: true,
        },
      ];
    },
    tabs() {
      let modelTabs = [];
      if (this.model.is_unload_order) {
        modelTabs = this.processingTabs
      } else if (this.model.type === 'local_market') {
        modelTabs = this.localMarketTabs
      } else if (this.model?.ticket?.customer_type === 'brs') {
        modelTabs = this.brsTabs
      }

      modelTabs = modelTabs.map((tab) => {
        let modelMapped = tab.modelMapped.map((item) => {
          if(!item.printable) {
            return item;
          }
          return {
            ...item,
            class: this.exportables
                    ?.find((exportable) => exportable.name === item.key)?.$checked ? item.class : 'd-none',
          };
        });
        return {
          ...tab,
          modelMapped,
        };
      })

      return modelTabs;
    },
    processingTabs(){
      return [
        {
          title: 'ADMIN',
          modelMapped: this.processingModelMapped('ADMIN').filter((field) => !field._denyShow)
        },
        {
          title: 'MITRA',
          modelMapped: this.processingModelMapped('MITRA').filter((field) => !field._denyShow)
        }
      ];
    },    
    localMarketTabs(){
      return []
    },
    brsTabs(){
      return [
        {
          title: 'ADMIN',
          modelMapped: this.brsModelMapped('ADMIN')
        },
        {
          title: 'MITRA',
          modelMapped: this.brsModelMapped('MITRA')
        },
      ]
    },
  },
  methods: {
    handlePrint(){
      this.$bvModal.show("export-modal");
    },
    processingModelMapped(role = 'ADMIN'){
      if (role)
      return [
            {
              key: `NOTA ARMADA`,
              class: 'd-block d-print-none',
              item: this.model,
              labelItemStyles: {
                fontWeight: "600",
              },
              labelItemClass: "text-dark-blue",
              valueClass: 'bg-white border p-3',
              tdClass: 'this-is-td',
              rowClass: 'row-class',
              value: {
                props: {
                  item: {
                    type: Object,
                    default() {
                      return {};
                    },
                  },
                  role: {
                    type: String,
                    default: 'ADMIN',
                  },
                },
                computed: {
                  fields() {
                    return [
                      // index
                      { 
                        key: 'index', 
                        label: 'No', 
                        sortable: false, 
                        style: { width: '1%' },
                        thStyle: "font-weight: 600; background: #F9FAFB",
                      },
                      {
                        key: "quantity",
                        label: "Biomassa (kg)",
                        thStyle: "font-weight: 600; background: #F9FAFB",
                        tdClass: "fw-bold",
                      },
                      {
                        key: "size",
                        label: "Size",
                        thStyle: "font-weight: 600; background: #F9FAFB",
                        tdClass: "fw-bold",
                      },
                      {
                        key: "unit_price",
                        label: "Harga (/kg)",
                        thStyle: "font-weight: 600; background: #F9FAFB",
                        tdClass: "fw-bold",
                        formatter: (value) =>
                          this.$numeral(value).format("$ 0,0.[000]"),
                      },
                      {
                        key: "total_price",
                        label: "Jumlah",
                        thStyle: "font-weight: 600; background: #F9FAFB",
                        tdClass: "fw-bold",
                        formatter: (value) =>
                          this.$numeral(value).format("$ 0,0.[000]"),
                      },
                      {
                        key: "label",
                        thStyle: "font-weight: 600; background: #F9FAFB",
                        tdClass: "fw-bold",
                        
                      },
                    ];
                  },
                  rowClass() {
                    return "";
                  },
                  totalBiomassa() {
                    return this.$numeral(
                      this.item.trip.trip_items.reduce((acc, cur) => acc + cur.quantity, 0)
                    ).format("0,0.[000]");
                  },
                  total(){
                    return this.$numeral(
                      this.item.trip.trip_items.reduce((acc, cur) => acc + cur.total_price, 0)
                    ).format("$ 0,0.[000]");
                  },
                  metaFields(){
                    return [
                      { 
                        key: 'Tanggal',
                        value: this.$moment(this.item.trip.tripped_at).format('DD MMMM YYYY'),
                        class: 'row',
                        labelClass: 'col-sm-12 col-md-4',
                        valueClass: 'col-sm-12 col-md-8',
                        showColon: true,
                        tdClass: 'p-0'
                      },
                      { 
                        key: 'Mitra',
                        value: this.item?.trip?.delivery_order?.customer?.name || '-',
                        class: 'row',
                        labelClass: 'col-sm-12 col-md-4',
                        valueClass: 'col-sm-12 col-md-8',
                        showColon: true,
                      },
                      { 
                        key: 'Tujuan Pabrik',
                        value: this.item?.trip?.customer?.name || '-',
                        class: 'row',
                        labelClass: 'col-sm-12 col-md-4',
                        valueClass: 'col-sm-12 col-md-8',
                        showColon: true,
                        _denyShow: role === 'MITRA'
                      },
                      {
                        key: this.lodash.upperFirst(this.$t('products.singular')),
                        value: this.item?.sale_items[0]?.purchase_item?.purchase_order?.product?.name || '-',
                        class: 'row',
                        labelItemClass: 'text-dark-blue',
                        labelClass: 'col-sm-12 col-md-4',
                        valueClass: 'col-sm-12 col-md-8',
                        showColon: true,
                        _denyShow: role === 'MITRA'
                      },
                      { 
                        key: 'No. DO',
                        item: this.item?.trip?.delivery_order?.id || '-',
                        class: 'row',
                        labelClass: 'col-sm-12 col-md-4',
                        labelItemClass: 'text-dark-blue',
                        valueClass: 'col-sm-12 col-md-8',
                        showColon: true,
                        _denyShow: role === 'MITRA',
                        value: {
                          props: {
                            item: {
                              type: String | Number | null,
                              default() {
                                return "";
                              },
                            },
                          },
                          template: /*html*/`
                            <div>
                              <router-link
                                :to="{ name: 'delivery-order-show', params: { id: item } }"
                              >
                                {{ item }}
                              </router-link>
                            </div>
                          `
                        },
                      },
                    ].filter((field) => !field._denyShow);
                  },
                  columns() {
                    return {
                      ["model"]: [
                        {
                          key: "key",
                          label: this.$t("models.key"),
                          component: Row,
                        },
                      ],
                    };
                  },
                },
                template: /*html*/ `
                    <div>
                      <div class="row">
                        <div class="col-md-4">
                          <b-table
                            :items="metaFields.slice(0, 3)"
                            :fields="columns['model']"
                            show-empty
                            :responsive="true"
                            thead-class="d-none"
                            borderless
                            tbody-tr-class="mapped-field-row"
                          >
                            <template #cell()="data">
                              <template v-if="data.field.component">
                                <component :is="data.field.component" v-bind="{item: data.item}" v-on="data.field['componentListeners'] || {}"></component>
                              </template>
                              <template v-else>{{ data.value }}</template>
                            </template>
                          </b-table>
                        </div>
                        <div class="col-md-4" v-if="metaFields.slice(3, 6).length">
                          <b-table
                            :items="metaFields.slice(3, 6)"
                            :fields="columns['model']"
                            show-empty
                            :responsive="true"
                            thead-class="d-none"
                            borderless
                            tbody-tr-class="mapped-field-row"
                          >
                            <template #cell()="data">
                              <template v-if="data.field.component">
                                <component :is="data.field.component" v-bind="{item: data.item}" v-on="data.field['componentListeners'] || {}"></component>
                              </template>
                              <template v-else>{{ data.value }}</template>
                            </template>
                          </b-table>
                        </div>
                      </div>
                      <b-table v-if="item.trip.trip_items" :tbody-tr-class="rowClass" :fields="fields" :items="item.trip.trip_items" borderless outlined class="mt-3">
                        <template v-slot:custom-foot="data">
                          <b-tr style="background: #F9FAFB">
                            <b-td class="text-left text-success" style="fontWeight: 600 !important" ></b-td>
                            <b-td class="text-left text-success" style="fontWeight: 600 !important" >{{totalBiomassa}}</b-td>
                            <b-td class="text-left text-success" style="fontWeight: 600 !important" ></b-td>
                            <b-td class="text-left text-success" style="fontWeight: 600 !important" ></b-td>
                            <b-td class="text-left text-success" style="fontWeight: 600 !important" >{{total}}</b-td>
                            <b-td class="text-left text-success" style="fontWeight: 600 !important" >{{item.trip.trip_items.length}}</b-td>
                          </b-tr>
                        </template>
                      </b-table>                      
                    </div>
                  `,
              },
              thStyle: "display: none",
              isRowHeader: true,
            },
            {
              key: `NOTA BONGKAR`,
              class: 'd-block d-print-none',
              item: this.model,
              // labelClass: "bg-primary text-white p-3 ",
              labelItemStyles: {
                fontWeight: "600",
              },
              labelItemClass: "text-dark-blue",
              valueClass: 'bg-white border p-3',
              value: {
                props: {
                  item: {
                    type: Object,
                    default() {
                      return {};
                    },
                  },
                },
                computed: {
                  isAdmin(){
                    return role === 'ADMIN'
                  },
                  fields() {
                    return [
                      // index
                      { 
                        key: 'index', 
                        label: 'No', 
                        sortable: false, 
                        style: { width: '1%' },
                        thStyle: "font-weight: 600; background: #F9FAFB",
                      },
                      {
                        key: "shrimp_type",
                        label: "Nama",
                        thStyle: "font-weight: 600; background: #F9FAFB",
                        tdClass: "fw-bold",
                        formatter: () => 'Vanamei',
                      },
                      {
                        key: "quantity",
                        label: "Biomassa (kg)",
                        thStyle: "font-weight: 600; background: #F9FAFB",
                        tdClass: "fw-bold",
                      },
                      {
                        key: "size",
                        label: "Size",
                        thStyle: "font-weight: 600; background: #F9FAFB",
                        tdClass: "fw-bold",
                      },
                      {
                        key: "unit_price",
                        label: "Harga",
                        thStyle: "font-weight: 600; background: #F9FAFB",
                        tdClass: "fw-bold",
                        formatter: (value) =>
                          this.$numeral(value).format("$ 0,0.[000]"),
                      },
                      {
                        key: "total_price",
                        label: "Jumlah",
                        thStyle: "font-weight: 600; background: #F9FAFB",
                        tdClass: "fw-bold",
                        formatter: (value) =>
                          this.$numeral(value).format("$ 0,0.[000]"),
                      },
                    ].filter((field) => !field._denyShow);
                  },
                  rowClass() {
                    return "";
                  },
                  totalBiomassa() {
                    return this.$numeral(
                      this.item.sale_items.reduce((acc, cur) => acc + cur.quantity, 0)
                    ).format("0,0.[000]");
                  },
                  total(){
                    return this.item.sale_items.reduce((acc, cur) => acc + cur.total_price, 0)
                  },
                  grandTotal(){
                    let acceleration = this.isAdmin ? this.findSaleAdditionalItemByName('Biaya Percepatan').total : 0;
                    return this.total + acceleration + this.findSaleAdditionalItemByName('PPH 22').total
                  },
                  metaFields(){
                    return [
                      { 
                        key: 'Tanggal',
                        value: this.$moment(this.item.trip.tripped_at).format('DD MMMM YYYY'),
                        class: 'row',
                        labelClass: 'col-sm-12 col-md-4',
                        valueClass: 'col-sm-12 col-md-8',
                        showColon: true,
                        tdClass: 'p-0'
                      },
                      { 
                        key: 'Pabrik',
                        value: this.item?.trip?.customer?.name || '-',
                        class: 'row',
                        labelClass: 'col-sm-12 col-md-4',
                        valueClass: 'col-sm-12 col-md-8',
                        showColon: true,
                      },
                      { 
                        key: 'Alamat',
                        value: this.item?.trip?.delivery_order?.shipping_address || '-',
                        class: 'row',
                        labelClass: 'col-sm-12 col-md-4',
                        valueClass: 'col-sm-12 col-md-8',
                        showColon: true,
                      },
                      { 
                        key: 'Supir',
                        value: this.item?.trip?.driver?.name || '-',
                        class: 'row',
                        labelClass: 'col-sm-12 col-md-4',
                        valueClass: 'col-sm-12 col-md-8',
                        showColon: true,
                      },
                      { 
                        key: 'Kendaraan',
                        value: this.item?.trip?.vehicle?.name || '-',
                        class: 'row',
                        labelClass: 'col-sm-12 col-md-4',
                        valueClass: 'col-sm-12 col-md-8',
                        showColon: true,
                      },
                    ]
                  },
                  columns() {
                    return {
                      ["model"]: [
                        {
                          key: "key",
                          label: this.$t("models.key"),
                          component: Row,
                        },
                      ],
                    };
                  },
                },
                methods: {
                  findSaleAdditionalItemByName(name){
                    return this.item.sale_additional_items.find(item => item.name === name) || {}
                  }
                },
                template: /*html*/ `
                    <div>
                      <div class="row">
                        <div class="col-md-4">
                          <b-table
                            :items="metaFields.slice(0, 3)"
                            :fields="columns['model']"
                            show-empty
                            :responsive="true"
                            thead-class="d-none"
                            borderless
                            tbody-tr-class="mapped-field-row"
                          >
                            <template #cell()="data">
                              <template v-if="data.field.component">
                                <component :is="data.field.component" v-bind="{item: data.item}" v-on="data.field['componentListeners'] || {}"></component>
                              </template>
                              <template v-else>{{ data.value }}</template>
                            </template>
                          </b-table>
                        </div>
                        <div class="col-md-4">
                          <b-table
                            :items="metaFields.slice(3, 6)"
                            :fields="columns['model']"
                            show-empty
                            :responsive="true"
                            thead-class="d-none"
                            borderless
                            tbody-tr-class="mapped-field-row"
                          >
                            <template #cell()="data">
                              <template v-if="data.field.component">
                                <component :is="data.field.component" v-bind="{item: data.item}" v-on="data.field['componentListeners'] || {}"></component>
                              </template>
                              <template v-else>{{ data.value }}</template>
                            </template>
                          </b-table>
                        </div>
                      </div>
                      <b-table-simple borderless class="border border-1">
                        <b-thead>
                          <b-tr>
                            <b-th style="font-weight: 700; background: rgb(249, 250, 251);">No</b-th>
                            <b-th style="font-weight: 700; background: rgb(249, 250, 251);">Nama</b-th>
                            <b-th style="font-weight: 700; background: rgb(249, 250, 251);" variant="" colspan="2" class="text-left">Nota Panen</b-th>
                            <b-th style="font-weight: 700; background: rgb(249, 250, 251);" variant="" colspan="2" class="text-left">Nota Bongkar</b-th>
                            <b-th style="font-weight: 700; background: rgb(249, 250, 251);" variant="" colspan="2" class="text-left">Performance</b-th>
                            <b-th style="font-weight: 700; background: rgb(249, 250, 251);">Harga (/kg)</b-th>
                            <b-th style="font-weight: 700; background: rgb(249, 250, 251);">Jumlah</b-th>
                          </b-tr>
                          <b-tr>
                            <b-th class="align-top" style="font-weight: 700; background: rgb(249, 250, 251);"></b-th>
                            <b-th class="align-top" style="font-weight: 700; background: rgb(249, 250, 251);"></b-th>
                            <b-th class="align-top pt-0" style="font-weight: 700; background: rgb(249, 250, 251);; width: 70px">Size</b-th>
                            <b-th class="align-top pt-0" style="font-weight: 700; background: rgb(249, 250, 251);">Biomassa</b-th>
                            <b-th class="align-top pt-0" style="font-weight: 700; background: rgb(249, 250, 251);; width: 70px">Size</b-th>
                            <b-th class="align-top pt-0" style="font-weight: 700; background: rgb(249, 250, 251);">Biomassa</b-th>
                            <b-th class="align-top pt-0" style="font-weight: 700; background: rgb(249, 250, 251);; width: 70px">Size</b-th>
                            <b-th class="align-top pt-0" style="font-weight: 700; background: rgb(249, 250, 251);">Biomassa</b-th>
                            <b-th class="align-top" style="font-weight: 700; background: rgb(249, 250, 251);"></b-th>
                            <b-th class="align-top" style="font-weight: 700; background: rgb(249, 250, 251);"></b-th>
                          </b-tr>
                        </b-thead>
                        <b-tbody>
                          <b-tr v-for="(item, index) in item.sale_items" :key="index">
                            <b-td>{{index + 1}}</b-td>
                            <b-td>Vanamei</b-td>
                            <b-td>{{item.initial_size}}</b-td>
                            <b-td>{{item.initial_quantity}}</b-td>
                            <b-td>{{item.size}}</b-td>
                            <b-td>{{item.quantity}}</b-td>
                            <b-td
                              :class="{
                                    'text-danger': item.size_performance < 5,
                                    'text-success': item.size_performance >= 5,
                                    'text-left': true,
                                }"
                            >{{$numeral(item.size_performance).format("0,0.[00]")}}%</b-td>
                            <b-td
                              :class="{
                                    'text-danger': item.size_performance < 5,
                                    'text-success': item.size_performance >= 5,
                                    'text-left': true,
                                }"
                            >{{$numeral(item.quantity_performance).format("0,0.[00]")}}%</b-td>
                            <b-td>{{$numeral(item.unit_price).format("$ 0,[00]")}}</b-td>
                            <b-td>{{$numeral(item.total_price).format("$ 0,[00]")}}</b-td>
                          </b-tr>
                        </b-tbody>
                      </b-table-simple>
                      <b-table v-if="item.sale_items" :tbody-tr-class="rowClass" :fields="fields" :items="item.sale_items" borderless outlined class="mt-3">
                        <template v-slot:custom-foot="data">
                          <b-tr style="background: #F9FAFB">
                            <b-td class="text-left text-success" style="fontWeight: 600 !important" ></b-td>
                            <b-td class="text-left text-success" style="fontWeight: 600 !important" >{{totalBiomassa}}</b-td>
                            <b-td class="text-left text-success" style="fontWeight: 600 !important" ></b-td>
                            <b-td class="text-left text-success" style="fontWeight: 600 !important" ></b-td>
                            <b-td class="text-left text-success" style="fontWeight: 600 !important" >{{$numeral(total).format('$ 0,0.[000]')}}</b-td>
                          </b-tr>
                        </template>
                      </b-table>
                      <div class="w-full">
                        <b-table-simple hover small caption-top stacked borderless class="ms-auto" style="width: 50%">
                          <b-tbody class="ps-3">
                            <b-tr>
                              <b-th stacked-heading="Sub Total:" class="text-right border-0">{{$numeral(total).format('$ 0,0.[000]')}}</b-th>
                              <b-th stacked-heading="Biaya Lain-Lain:" class="text-right border-0"></b-th>
                              <b-th v-if="isAdmin" stacked-heading="Biaya Akselerasi:" class="text-right border-0">{{$numeral(Math.abs(findSaleAdditionalItemByName('Biaya Percepatan').total)).format('$ 0,0.[000]')}}</b-th>
                              <b-th stacked-heading="PPh:" class="text-right border-0">{{$numeral(Math.abs(findSaleAdditionalItemByName('PPH 22').total)).format('$ 0,0.[000]')}}</b-th>
                              <b-th stacked-heading="Total:" class="text-right border-0 text-success">{{$numeral(grandTotal).format('$ 0,0.[000]')}}</b-th>
                            </b-tr>
                          </b-tbody>
                        </b-table-simple>
                      </div>
                    </div>
                  `,
              },
            },
            // balancing
            {
              key: "Balancing",
              class: 'd-block d-print-none',
              item: this.model,
              valueClass: 'bg-white border p-3',
              _denyShow: role !== 'ADMIN',
              value: {
                props: {
                  item: {
                    type: Object,
                    default() {
                      return {};
                    },
                  },
                },
                data(){
                  return {
                    discountsVisible: false,
                    partnerTransferVisible: true,
                  }
                },
                computed: {
                  fields() {
                    return [
                      {
                        key: "index",
                        label: "No.",
                        sortable: false,
                        thStyle: "font-weight: 600; background: #F9FAFB; width: 10px",
                        tdClass: "fw-bold bg-white"
                      },
                      {
                        key: "size",
                        label: "Nama Barang",
                        formatter: (value) => `Udang Vaname / Size ${value}`,
                        sortable: false,
                        thStyle: "font-weight: 600; background: #F9FAFB; width: 80px",
                        tdClass: "fw-bold bg-white"
                      },
                      {
                        key: "quantity",
                        label: "Biomassa (kg)",
                        tdClass: "text-left fw-bold bg-white",
                        thStyle: "font-weight: 600; background: #F9FAFB; width: 80px",
                        formatter: (value) => {
                          return (
                            (value ? this.$numeral(value).format("0,0.[00]") : "")
                          );
                        },
                      },
                      {
                        key: "unit_price",
                        label: "Harga",
                        thStyle: "font-weight: 600; background: #F9FAFB; width: 80px",
                        tdClass: "fw-bold bg-white",
                        formatter: (value) => {
                          return value
                            ? this.$numeral(value).format("$ 0,[00]")
                            : "";
                        },
                      },
                      {
                        key: "total_price",
                        label: "Jumlah",
                        thStyle: "font-weight: 600; background: #F9FAFB; width: 80px",
                        tdClass: "fw-bold bg-white",
                        formatter: (value) => {
                          return value
                            ? this.$numeral(value).format("$ 0,[00]")
                            : "";
                        },
                      },
                    ];
                  },
                  rowClass() {
                    return "";
                  },
                  value(){
                    return this.item
                  },
                  totalBiomassa(){
                    return this.item.trip?.unload.sale_items.reduce((acc, item) => acc + item.quantity, 0)
                  },
                  subTotal(){
                    return this.item.trip?.unload.sale_items.reduce((acc, item) => acc + item.total_price, 0)
                  },
                  profitShare(){
                    let expenses = this.item.sales_reports.filter(({ category }) => category === 'expense')
                    return expenses.find(({ sales_reportable_type }) => sales_reportable_type === 'App\\Models\\BalancingTransaction') || {}
                  },
                  cogs(){
                    return this.item.sales_reports.filter(({category}) => category === 'cost_of_goods_sold')
                  },
                  groupedBySubCategory(){
                    return this.lodash.groupBy(this.cogs, 'sub_category')
                  },
                  ice(){
                    return this.item.sales_reports.find(({sub_category}) => sub_category === 'ice')?.total || 0
                  },
                  labourCost(){
                    return Math.abs(this.item.sales_reports
                            .filter(({sub_category}) => sub_category === 'labour')
                            .reduce((prev, curr) => {
                              return curr.total += prev
                            }, 0))
                  },
                  shippingCost(){
                    return Math.abs(this.item.sales_reports
                            .filter(({sub_category}) => sub_category === 'delivery')
                            .reduce((prev, curr) => {
                              return curr.total += prev
                            }, 0))
                  },
                  total(){
                    return this.ice + this.labourCost + this.shippingCost + Math.abs(this.item.total_profit) + Math.abs(this.profitShare.total)
                  },
                  transferToPartnerModelMapped(){
                          // <b-td stacked-heading="TRANSFER KE MITRA" class="balancing-field text-success border-0">{{$numeral(total).format('$ 0,0.[000]')}}</b-td>
                          // <b-th stacked-heading="Glazing" class="text-left balancing-field">{{$numeral(Math.abs(ice)).format('$ 0,0.[000]')}}</b-th>
                          // <b-td stacked-heading="Labour Cost" class="balancing-field">{{$numeral(labourCost).format('$ 0,0.[000]')}}</b-td>
                          // <b-td stacked-heading="Shipping Cost" class="balancing-field">{{$numeral(Math.abs(item.total_profit)).format('$ 0,0.[000]')}}</b-td>
                          // <b-td stacked-heading="Bagi Hasil" class="balancing-field">{{$numeral(Math.abs(profitShare.total)).format('$ 0,0.[000]')}}</b-td>
                      return [
                        {
                          key: `Glazing`,
                          value: this.$numeral(Math.abs(this.ice)).format('$ 0,0.[000]'),
                          class: 'row',
                          labelClass: 'col-sm-12 col-md-4 col-xl-3',
                          valueClass: 'col-sm-12 col-md-8 col-xl-9 text-end',
                          showColon: true,
                        },
                        {
                          key: `Labour Cost`,
                          value: this.$numeral(this.labourCost).format('$ 0,0.[000]'),
                          class: 'row',
                          labelClass: 'col-sm-12 col-md-4 col-xl-3',
                          valueClass: 'col-sm-12 col-md-8 col-xl-9 text-end',
                          showColon: true,
                        },
                        {
                          key: `Shipping Cost`,
                          value: this.$numeral(Math.abs(this.shippingCost)).format('$ 0,0.[000]'),
                          class: 'row',
                          labelClass: 'col-sm-12 col-md-4 col-xl-3',
                          valueClass: 'col-sm-12 col-md-8 col-xl-9 text-end',
                          showColon: true,
                        },
                        {
                          key: `Bagi Hasil`,
                          value: this.$numeral(Math.abs(this.profitShare.total)).format('$ 0,0.[000]'),
                          class: 'row',
                          labelClass: 'col-sm-12 col-md-4 col-xl-3',
                          valueClass: 'col-sm-12 col-md-8 col-xl-9 text-end',
                          showColon: true,
                        },
                      ];
                    }
                },
                methods: {
                  findSaleAdditionalItemByName(name){
                    return this.item.sale_additional_items.find(item => item.name === name) || {}
                  }
                },
                template: /*html*/ `
                <div class="p-3 bg-white">
                  <b-table :tbody-tr-class="rowClass" :fields="fields" :items="item.sale_items" borderless outlined>
                    <template v-slot:custom-foot="data">
                      <b-tr>
                        <b-td class="text-left text-success" style="fontWeight: 600 !important" ></b-td>
                        <b-td class="text-left text-success" style="fontWeight: 600 !important" >Subtotal Penjualan</b-td>
                        <b-td class="text-left text-success" style="fontWeight: 600 !important" >{{totalBiomassa}}</b-td>
                        <b-td class="text-left text-success" style="fontWeight: 600 !important" ></b-td>
                        <b-td class="text-left text-success" style="fontWeight: 600 !important" >{{$numeral(subTotal).format('$ 0,0.[000]')}}</b-td>
                      </b-tr>
                    </template>
                  </b-table>
                  <div class="w-100 d-flex flex-column align-items-end">
                    <b-table-simple hover small caption-top stacked borderless class="bg-gray-100" style="width: 50%;">
                      <b-tbody class="px-3 border">
                        <b-tr>
                          <b-th stacked-heading="Nota Panen" class="text-left border-0 balancing-field">{{$numeral(item.trip.total).format('$ 0,0.[000]')}}</b-th>
                          <b-td stacked-heading="Pph" class="balancing-field">{{$numeral(Math.abs(findSaleAdditionalItemByName('PPH 22').total)).format('$ 0,0.[000]')}}</b-td>
                          <b-td stacked-heading="Margin JALA" class="balancing-field">{{$numeral(item.total_service_fee).format('$ 0,0.[000]')}}</b-td>
                          <b-td 
                            stacked-heading="TRANSFER KE MITRA" 
                            class="balancing-field text-success"
                            @click="partnerTransferVisible = !partnerTransferVisible"
                            role="button"
                          >
                          {{$numeral(total).format('$ 0,0.[000]')}}
                            <i v-if="partnerTransferVisible" class="text-dark bx bxs-right-arrow"></i>
                            <i v-else class="text-dark bx bxs-down-arrow"></i>
                          </b-td>
                        </b-tr>
                        <b-tr v-show="partnerTransferVisible">
                          <b-th stacked-heading="Glazing" class="ps-1 text-left balancing-field partner-transfer border-0">{{$numeral(Math.abs(ice)).format('$ 0,0.[000]')}}</b-th>
                          <b-td stacked-heading="Labour Cost" class="ps-1 balancing-field partner-transfer">{{$numeral(labourCost).format('$ 0,0.[000]')}}</b-td>
                          <b-td stacked-heading="Shipping Cost" class="ps-1 balancing-field partner-transfer">{{$numeral(Math.abs(item.shippingCost)).format('$ 0,0.[000]')}}</b-td>
                          <b-td stacked-heading="Bagi Hasil" class="ps-1 balancing-field partner-transfer">{{$numeral(Math.abs(profitShare.total)).format('$ 0,0.[000]')}}</b-td>  
                        </b-tr>
                      </b-tbody>
                    </b-table-simple>
                  </div>
                </div>
                `
              },
            },
            {
              key: "Balancing",
              class: 'd-block d-print-none',
              item: this.model,
              valueClass: 'bg-white border p-3',
              _denyShow: role === 'ADMIN',
              value: {
                props: {
                  item: {
                    type: Object,
                    default() {
                      return {}
                    },
                  },
                },
                computed: {
                  fields() {
                    return [
                      {
                        key: "size",
                        label: "Nama Barang",
                        formatter: (value) => `Udang Vaname / Size ${value}`,
                        sortable: false,
                        thStyle: "font-weight: 600; background: #F9FAFB; width: 80px",
                        tdClass: "fw-bold bg-white"
                      },
                      {
                        key: "quantity",
                        label: "Biomassa (kg)",
                        tdClass: "text-left fw-bold bg-white",
                        thStyle: "font-weight: 600; background: #F9FAFB; width: 80px",
                        formatter: (value) => {
                          return (
                            (value ? this.$numeral(value).format("0,0.[00]") : "")
                          );
                        },
                      },
                      {
                        key: "unit_price",
                        label: "Harga",
                        thStyle: "font-weight: 600; background: #F9FAFB; width: 80px",
                        tdClass: "fw-bold bg-white",
                        formatter: (value) => {
                          return value
                            ? this.$numeral(value).format("$ 0,[00]")
                            : "";
                        },
                      },
                      {
                        key: "total_price",
                        label: "Jumlah",
                        thStyle: "font-weight: 600; background: #F9FAFB; width: 80px",
                        tdClass: "fw-bold bg-white",
                        formatter: (value) => {
                          return value
                            ? this.$numeral(value).format("$ 0,[00]")
                            : "";
                        },
                      },
                    ];
                  },
                  rowClass() {
                    return "";
                  },
                  value(){
                    return this.item
                  },
                  totalBiomassa(){
                    return this.item.trip?.unload.sale_items.reduce((acc, item) => acc + item.quantity, 0)
                  },
                  subTotal(){
                    return this.item.trip?.unload.sale_items.reduce((acc, item) => acc + item.total_price, 0)
                  },
                  profitShare(){
                    let expenses = this.item.sales_reports.filter(({ category }) => category === 'expense')
                    return expenses.find(({ sales_reportable_type }) => sales_reportable_type === 'App\\Models\\BalancingTransaction') || {}
                  },
                  cogs(){
                    return this.item.sales_reports.filter(({category}) => category === 'cost_of_goods_sold')
                  },
                  groupedBySubCategory(){
                    return this.lodash.groupBy(this.cogs, 'sub_category')
                  },
                  ice(){
                    return this.item.sales_reports.find(({sub_category}) => sub_category === 'ice')?.total || 0
                  },
                  labourCost(){
                    return Math.abs(this.item.sales_reports
                            .filter(({sub_category}) => sub_category === 'labour')
                            .reduce((prev, curr) => {
                              return curr.total += prev
                            }, 0))
                  },
                  shippingCost(){
                    return Math.abs(this.item.sales_reports
                            .filter(({sub_category}) => sub_category === 'delivery')
                            .reduce((prev, curr) => {
                              return curr.total += prev
                            }, 0))
                  },
                  total(){
                    return this.ice + this.labourCost + this.shippingCost + Math.abs(this.item.total_profit) + Math.abs(this.profitShare.total)
                  },
                },
                methods: {
                  findSaleAdditionalItemByName(name){
                    return this.item.sale_additional_items.find(item => item.name === name) || {}
                  }
                },
                template: /*html*/ `
                <div class="p-3 bg-white">
                  <b-table :tbody-tr-class="rowClass" :fields="fields" :items="item.trip?.unload.sale_items" borderless outlined>
                    <template v-slot:custom-foot="data">
                      <b-tr>
                        <b-td class="text-left text-success" style="fontWeight: 600 !important" >Subtotal Penjualan</b-td>
                        <b-td class="text-left text-success" style="fontWeight: 600 !important" >{{totalBiomassa}}</b-td>
                        <b-td class="text-left text-success" style="fontWeight: 600 !important" ></b-td>
                        <b-td class="text-left text-success" style="fontWeight: 600 !important" >{{$numeral(subTotal).format('$ 0,0.[000]')}}</b-td>
                      </b-tr>
                    </template>
                  </b-table>
                  <div class="w-100 d-flex flex-column align-items-end">
                    <b-table-simple hover small caption-top stacked borderless class="bg-gray-100" style="width: 40%;">
                      <b-tbody class="px-3 border">
                        <b-tr>
                          <b-th stacked-heading="Nota Panen" class="text-left border-0 balancing-field">{{$numeral(item.trip.total).format('$ 0,0.[000]')}}</b-th>
                          <b-td stacked-heading="Pph" class="balancing-field">{{$numeral(Math.abs(findSaleAdditionalItemByName('PPH 22').total)).format('$ 0,0.[000]')}}</b-td>
                          <b-td stacked-heading="Margin JALA" class="balancing-field">{{$numeral(item.total_service_fee).format('$ 0,0.[000]')}}</b-td>
                          <b-td stacked-heading="TRANSFER KE MITRA" class="balancing-field text-success">{{$numeral(total).format('$ 0,0.[000]')}}</b-td>
                        </b-tr>
                      </b-tbody>
                    </b-table-simple>
                  </div>
                </div>
                `
              },
            },
            // print view
            {
              key: 'JALA Logo',
              labelClass: 'd-none',
              valueClass: 'text-center',
              class: 'd-none d-print-block',
              value: {
                template: /*html*/ `
                  <img src="/jala.svg" alt="JALA Logo" class="img-fluid" style="max-width: 200px">
                `
              }
            },
            {
              key: `NOTA ARMADA`,
              label: {
                template: /*html*/`
                  <div class="custom-label bg-primary text-white p-3 py-2 gap-3 align-items-center" style="display: flex;">
                    <router-link :to="'/trips/${this.model.trip.id}'">
                      <h6 class="label-item border border-top-0 border-start-0 border-end-0" style="font-size: 1rem; color: white; margin: 0px; font-weight: 400;">
                        Nota Armada - Purchased Shrimp  
                      </h6>
                    </router-link>
                    <div style="font-size: 1rem; color: white; margin: 0px; font-weight: 400;">${this.$moment.utc(this.model.trip.tripped_at).local().format('DD MMM YYYY')}</div>
                  </div>
                `
              },
              class: 'd-none d-print-block',
              item: this.model.trip?.trip_items,
              labelClass: "bg-primary text-white p-3 ",
              labelItemStyles: {
                fontSize: "1rem",
                color: "white",
                margin: "0",
                fontWeight: "400",
                '--date': '2021-01-01'
              },
              valueClass: 'bg-gray-100 px-2 border',
              value: {
                props: {
                  item: {
                    type: Array,
                    default() {
                      return [];
                    },
                  },
                },
                computed: {
                  fields() {
                    return [
                      // index
                      { key: 'index', label: 'No', sortable: false, style: { width: '1%' } },
                      {
                        key: "purchase_item.purchase_order_id",
                        label: "Nota Panen",
                        sortable: false,
                        style: { width: "1%" },
                        thClass: "text-dark-blue",
                        thStyle: "font-weight: 600",
                        tdClass: "fw-bold",
                      },
                      {
                        key: "id",
                        label: "No.item",
                        sortable: false,
                        style: { width: "1%" },
                        thClass: "text-dark-blue",
                        thStyle: "font-weight: 600",
                        tdClass: "fw-bold",
                      },
                      {
                        key: "quantity",
                        label: "Biomassa (kg)",
                        thClass: "text-dark-blue",
                        thStyle: "font-weight: 600",
                        tdClass: "fw-bold",
                      },
                      {
                        key: "size",
                        label: "Size",
                        thClass: "text-dark-blue",
                        thStyle: "font-weight: 600",
                        tdClass: "fw-bold",
                      },
                      {
                        key: "unit_price",
                        label: "Harga",
                        thClass: "text-dark-blue",
                        thStyle: "font-weight: 600",
                        tdClass: "fw-bold",
                        formatter: (value) =>
                          this.$numeral(value).format("$ 0,0.[000]"),
                      },
                      {
                        key: "total_price",
                        label: "Jumlah",
                        thClass: "text-dark-blue",
                        thStyle: "font-weight: 600",
                        tdClass: "fw-bold",
                        formatter: (value) =>
                          this.$numeral(value).format("$ 0,0.[000]"),
                      },
                      {
                        key: "label",
                        label: "Label",
                        thClass: "text-dark-blue",
                        thStyle: "font-weight: 600",
                        tdClass: "fw-bold",
                      },
                    ];
                  },
                  rowClass() {
                    return "";
                  },
                  totalBiomassa() {
                    return this.$numeral(
                      this.item.reduce((acc, cur) => acc + cur.quantity, 0)
                    ).format("0,0.[000]");
                  },
                  total(){
                    return this.$numeral(
                      this.item.reduce((acc, cur) => acc + cur.total_price, 0)
                    ).format("$ 0,0.[000]");
                  }
                },
                template: /*html*/ `
                    <b-table :tbody-tr-class="rowClass" :fields="fields" :items="item" borderless>
                      <template v-slot:custom-foot="data">
                        <b-tr>
                          <b-td class="text-left text-success" style="fontWeight: 600 !important" ></b-td>
                          <b-td class="text-left text-success" style="fontWeight: 600 !important" ></b-td>
                          <b-td class="text-left text-success" style="fontWeight: 600 !important" ></b-td>
                          <b-td class="text-left text-success" style="fontWeight: 600 !important" >{{totalBiomassa}}</b-td>
                          <b-td class="text-left text-success" style="fontWeight: 600 !important" ></b-td>
                          <b-td class="text-left text-success" style="fontWeight: 600 !important" ></b-td>
                          <b-td class="text-left text-success" style="fontWeight: 600 !important" >{{total}}</b-td>
                          <b-td class="text-left text-success" style="fontWeight: 600 !important" ></b-td>
                        </b-tr>
                      </template>
                    </b-table>
                  `,
              },
              printable: true,
            },
            {
              printable: true,
              key: "SURAT JALAN",
              class: 'd-none d-print-block',
              label: {
                template: /*html*/`
                  <div class="custom-label bg-primary text-white p-3 py-2 gap-3 align-items-center" style="display: flex;">
                    <router-link :to="'/delivery_orders/${this.model.trip.delivery_order.id}'">
                      <h6 class="label-item border border-top-0 border-start-0 border-end-0" style="font-size: 1rem; color: white; margin: 0px; font-weight: 400;">
                        Surat Jalan (DO)
                      </h6>
                    </router-link>
                    <div style="font-size: 1rem; color: white; margin: 0px; font-weight: 400;">${this.$moment.utc(this.model.trip.delivery_order.ordered_at).local().format('DD MMM YYYY')}</div>
                  </div>
                `
              },
              item: this.model.trip,
              labelClass: "bg-primary text-white p-3",
              labelItemStyles: {
                fontSize: "1rem",
                color: "white",
                margin: "0",
                fontWeight: "400",
              },
              valueClass: 'border bg-gray-100 px-2',
              value: {
                props: {
                  item: {
                    type: Object,
                    default() {
                      return {};
                    },
                  },
                },
                computed: {
                  deliveryOrderLink: function (){
                    return `${window.location.origin}/delivery_orders/${this.item.delivery_order.id}`
                  },
                },
                template: /*html*/ `
                  <div class="row">
                    <div class="col-md-4">
                      <b-table-simple hover small caption-top stacked borderless>
                        <caption class="ps-3">Delivery Order</caption>
                        <b-tbody class="ps-3">
                          <b-tr>
                            <b-td style="border: none">
                              <span class="text-dark-blue">No:</span> <span class="fw-bold">{{item.delivery_order.order_id}}</span>
                            </b-td>
                            <b-td>
                              <span class="text-dark-blue">Tanggal Muat:</span> <span class="fw-bold">{{$moment.utc(item.delivery_order.ordered_at).local().format('DD MMM YYYY')}}</span>
                            </b-td>
                            <b-td>
                              <span class="text-dark-blue">Tanggal Bongkar:</span> <span class="fw-bold">{{$moment.utc(item.delivery_order.due_at).local().format('DD MMM YYYY')}}</span>
                            </b-td>
                            <b-td>
                              <span class="text-dark-blue">Armada:</span> <span class="fw-bold">{{item.vehicle.name}} ({{item.vehicle.license_plate}})</span>
                            </b-td>
                            <b-td>
                              <span class="text-dark-blue">Supir:</span> <span class="fw-bold">{{item.driver.name}} ({{item.driver.phone_number}})</span>
                            </b-td>
                          </b-tr>
                        </b-tbody>
                      </b-table-simple>
                    </div>
                    <div class="col-md-4">
                      <b-table-simple hover small caption-top stacked borderless>
                        <caption class="ps-3">Shipping Address</caption>
                        <b-tbody class="ps-3">
                          <b-tr>
                            <b-td style="border: none">
                              <span class="text-dark-blue">To:</span> <span class="fw-bold">{{item.customer.name}}</span>
                            </b-td>
                            <b-td>
                              <span class="text-dark-blue">PT:</span> <span class="fw-bold">{{item.customer.name}}</span>
                            </b-td>
                            <b-td>
                              <span class="text-dark-blue">Alamat:</span> <span class="fw-bold">
                                <span style="white-space: pre-wrap ;" v-html="item.delivery_order.shipping_address"></span>
                              </span>
                            </b-td>
                          </b-tr>
                        </b-tbody>
                      </b-table-simple>
                    </div>
                    
                  </div>
                  `,
              },
            },
            {
              printable: true,
              key: "NOTA BONGKAR",
              class: 'd-none d-print-block',
              label: {
                template: /*html*/`
                  <div class="custom-label bg-primary text-white p-3 py-2 gap-3 align-items-center" style="display: flex;">
                    <router-link :to="'/unloads/${this.model.id}'">
                      <h6 class="label-item border border-top-0 border-start-0 border-end-0" style="font-size: 1rem; color: white; margin: 0px; font-weight: 400;">
                        Nota Bongkar
                      </h6>
                    </router-link>
                    <div style="font-size: 1rem; color: white; margin: 0px; font-weight: 400;">${this.$moment.utc(this.model.ordered_at).local().format('DD MMM YYYY')}</div>
                  </div>
                `
              },
              item: this.model.trip?.unload.sale_items,
              labelClass: "bg-primary text-white p-3",
              labelItemStyles: {
                fontSize: "1rem",
                color: "white",
                margin: "0",
                fontWeight: "400",
              },
              valueClass: 'bg-gray-100 border ps-3',
              value: {
                props: {
                  item: {
                    type: Array,
                    default() {
                      return [];
                    },
                  },
                },
                computed: {
                  fields() {
                    return [
                      {
                        key: "shrimp_type",
                        label: "Jenis Udang",
                        formatter: () => 'Vanamei',
                        sortable: false,
                        style: { width: "1%" },
                      },
                      // {
                      //   key: "trip_item.purchase_item.size",
                      //   label: "Size",
                      //   thClass: "text-left",
                      //   style: { width: "300px" },
                      //   formatter: (value) => {
                      //     return `Besar (${value})`;
                      //   },
                      // },
                      {
                        key: "quantity",
                        label: "Biomassa",
                        thClass: "text-left",
                        tdClass: "text-left",
                        formatter: (value) => {
                          return (
                            (value ? this.$numeral(value).format("0,0.[00]") : "") +
                            " Kg"
                          );
                        },
                      },
                      {
                        key: "size_performance",
                        label: "Size",
                        thClass: "text-left",
                        tdClass: (data) => {
                          let classes = "text-left";
                          if (data >= 5) {
                            classes += " text-success";
                          } else {
                            classes += " text-danger";
                          }
                          return classes;
                        },
                        formatter: (value) => {
                          return (
                            (value
                              ? this.$numeral(value).format("0,0.[00]")
                              : "0") + "%"
                          );
                        },
                      },
                      {
                        key: "quantity_performance",
                        label: "Biomassa",
                        thClass: "text-left",
                        tdClass: (data) => {
                          let classes = "text-left";
                          // if (row._index) {
                          if (data >= 5) {
                            classes += " text-success";
                          } else {
                            classes += " text-danger";
                          }
                          // }
                          return classes;
                        },
                        value: {
                          props: { item: { type: String, default: "" } },
                          template: `<span></span>`,
                        },
                        formatter: (value) => {
                          return value !== null
                            ? this.$numeral(value).format("0,0.[00]") + "%"
                            : "";
                        },
                      },
                      {
                        key: "quality",
                        label: this.lodash.startCase(this.$t("unloads.quality")),
                      },
                      {
                        key: "unit_price",
                        label: "Harga (/kg)",
                        formatter: (value) => {
                          return value
                            ? this.$numeral(value).format("$ 0,[00]")
                            : "";
                        },
                      },
                      {
                        key: "total_price",
                        label: "Jumlah",
                        formatter: (value) => {
                          return value
                            ? this.$numeral(value).format("$ 0,[00]")
                            : "";
                        },
                      },
                    ];
                  },
                  rowClass() {
                    return "";
                  },
                  value(){
                    return this.item
                  }
                },
                template: /*html*/ `
                  <b-table-simple borderless>
                    <b-thead>
                        <b-tr>
                            <b-th style="fontWeight: 400 !important">No</b-th>
                            <b-th style="fontWeight: 400 !important">Jenis Udang</b-th>
                            <b-th style="fontWeight: 400 !important">Size</b-th>
                            <b-th style="fontWeight: 400 !important">Biomassa (kg)</b-th>
                            <b-th style="fontWeight: 400 !important" variant="" colspan="2" class="text-left">Performance</b-th>
                            <b-th style="fontWeight: 400 !important">Harga (/kg)</b-th>
                            <b-th style="fontWeight: 400 !important">Jumlah</b-th>
                        </b-tr>
                        <b-tr>
                            <b-th class="align-top" style="fontWeight: 400 !important"></b-th>
                            <b-th class="align-top" style="fontWeight: 400 !important"></b-th>
                            <b-th class="align-top" style="fontWeight: 400 !important"></b-th>
                            <b-th class="align-top" style="fontWeight: 400 !important"></b-th>
                            <b-th class="align-top" style="fontWeight: 400 !important; width: 70px">Size</b-th>
                            <b-th class="align-top" style="fontWeight: 400 !important">Biomassa</b-th>
                            <b-th class="align-top" style="fontWeight: 400 !important"></b-th>
                            <b-th class="align-top" style="fontWeight: 400 !important"></b-th>
                        </b-tr>
                    </b-thead>
                    <b-tbody>
                        <b-tr v-for="(value, index) in item" :key="index">
                            <b-td
                                v-if="value.rowspan"
                                :rowspan="value.rowspan"
                                style="fontWeight: 600 !important"
                                class="align-top fw-bold"
                            >{{value._index}}</b-td>
                            <b-td
                                v-if="value.rowspan"
                                :rowspan="value.rowspan"
                                style="fontWeight: 600 !important"
                                class="align-top fw-bold"
                            >{{value._index ? 'Vaname' : ''}}</b-td>
                            <b-td
                                v-if="value.rowspan"
                                :rowspan="value.rowspan"                            
                                class="text-left align-top">
                                <div style="fontWeight: 600 !important" >
                                  Besar ({{ value.trip_item ? $numeral(value.initial_size).format("0,0.[00]"): '' }})
                                </div>
                            </b-td>
                            <b-td
                                v-if="value.rowspan"
                                :rowspan="value.rowspan"
                                style="fontWeight: 600 !important" 
                                class="text-left align-top">{{ value.trip_item ? $numeral(value.initial_quantity).format("0,0.[00]"): '' }}</b-td>
                            <b-td
                                :class="{
                                    'text-danger': value.size_performance < 5,
                                    'text-success': value.size_performance >= 5,
                                    'text-left': true,
                                    'align-middle': true,
                                    'fw-bold': true,
                                }"
                                style="fontWeight: 600 !important" 
                            >{{ $numeral(value.size_performance).format("0,0.[00]")+'%' }}</b-td>
                            <b-td
                                v-if="value.rowspan"
                                :class="{
                                    'text-danger': value.quantity_performance < 5,
                                    'text-success': value.quantity_performance >= 5,
                                    'text-left': true,
                                    'align-middle': true,
                                    'fw-bold': true,
                                }"
                                :rowspan="value.rowspan"
                                style="fontWeight: 600 !important"
                            >{{ value.quantity_performance !== null ? $numeral(value.quantity_performance).format("0,0.[00]")+'%': '' }}</b-td>
                            <b-td class="fw-bold">{{ $numeral(value.unit_price).format("$ 0,[00]") }}</b-td>
                            <b-td class="fw-bold">{{ $numeral(value.total_price).format("$ 0,[00]") }}</b-td>
                        </b-tr>
                    </b-tbody>
                </b-table-simple>
                  `,
              },
            },
            {
              printable: true,
              key: `PENERIMAAN PENJUALAN`,
              label: {
                template: /*html*/`
                  <div class="custom-label bg-primary text-white p-3 py-2 gap-3 align-items-center" style="display: flex;">
                    <router-link :to="'/sale_invoices/${this.model.id}'">
                      <h6 class="label-item border border-top-0 border-start-0 border-end-0" style="font-size: 1rem; color: white; margin: 0px; font-weight: 400;">
                        Penerimaan Penjualan
                      </h6>
                    </router-link>
                  </div>
                `
              },
              class: 'd-none d-print-block',
              item: this.model.payments,
              labelClass: "bg-primary text-white p-3 ",
              labelItemStyles: {
                fontSize: "1rem",
                color: "white",
                margin: "0",
                fontWeight: "400",
              },
              valueClass: 'bg-gray-100 px-2 border',
              value: {
                props: {
                  item: {
                    type: Array,
                    default() {
                      return [];
                    },
                  },
                },
                computed: {
                  fields() {
                    return [
                      // index
                      { key: 'invoice_number', label: 'No.Penjualan', sortable: false, style: { width: '1%' } },
                      {
                        key: "paid_at",
                        label: "Tanggal",
                        sortable: false,
                        style: { width: "1%" },
                        thClass: "text-dark-blue",
                        thStyle: "font-weight: 600",
                        tdClass: "fw-bold",
                      },
                      {
                        key: "nominal",
                        label: "Nominal",
                        sortable: false,
                        style: { width: "1%" },
                        thClass: "text-dark-blue",
                        thStyle: "font-weight: 600",
                        tdClass: "fw-bold",
                        formatter: (value) =>
                          this.$numeral(value).format("$ 0,0.[000]"),
                      },
                      {
                        key: "from_bank_account",
                        label: "Pengirim",
                        sortable: false,
                        style: { width: "1%" },
                        thClass: "text-dark-blue",
                        thStyle: "font-weight: 600",
                        tdClass: "fw-bold",
                        formatter: (value) => `${this.lodash.startCase(value.customer.name)} - ${value.account_number} - ${value.bank.name}`
                      },
                      {
                        key: "to_bank_account",
                        label: "Penerima",
                        sortable: false,
                        style: { width: "1%" },
                        thClass: "text-dark-blue",
                        thStyle: "font-weight: 600",
                        tdClass: "fw-bold",
                        formatter: (value) => `${this.lodash.startCase(value.customer.name)} - ${value.account_number} - ${value.bank.name}`
                      },
                    ];
                  },
                  rowClass() {
                    return "";
                  },
                  totalBiomassa() {
                    return this.$numeral(
                      this.item.reduce((acc, cur) => acc + cur.quantity, 0)
                    ).format("0,0.[000]");
                  },
                  total(){
                    return this.$numeral(
                      this.item.reduce((acc, cur) => acc + cur.total_price, 0)
                    ).format("$ 0,0.[000]");
                  }
                },
                template: /*html*/ `
                    <b-table :tbody-tr-class="rowClass" :fields="fields" :items="item" borderless>
                      
                    </b-table>
                  `,
              },
            },
            {
              key: "Total",
              class: 'd-none d-print-block',
              item: this.model,
              labelClass: "bg-primary text-white p-3 ms-auto",
              labelStyles: {
                width: "50%",
              },
              // valueStyles: {
              //   width: "50%",
              // },
              labelItemStyles: {
                fontSize: "1rem",
                color: "white",
                margin: "0",
                fontWeight: "400",
              },
              trClass: "text-right",
              valueClass: 'ms-auto',
              value: {
                props: {
                  item: {
                    type: Object,
                    default() {
                      return {};
                    },
                  },
                },
                computed: {
                  isAdmin(){
                    return role === 'admin'
                  },
                  fields() {
                    return [
                      {
                        key: "purchase_item.purchase_order_id",
                        label: "Nota Panen",
                        sortable: false,
                        style: { width: "1%" },
                        thClass: "text-dark-blue",
                        thStyle: "font-weight: 600",
                        tdClass: "fw-bold",
                      },
                      {
                        key: "quantity",
                        label: "Biomassa (kg)",
                        thClass: "text-dark-blue",
                        thStyle: "font-weight: 600",
                        tdClass: "fw-bold",
                      },
                      {
                        key: "size",
                        label: "Size",
                        thClass: "text-dark-blue",
                        thStyle: "font-weight: 600",
                        tdClass: "fw-bold",
                      },
                      {
                        key: "unit_price",
                        label: "Harga",
                        thClass: "text-dark-blue",
                        thStyle: "font-weight: 600",
                        tdClass: "fw-bold",
                        formatter: (value) =>
                          this.$numeral(value).format("$ 0,0.[000]"),
                      },
                      {
                        key: "total_price",
                        label: "Jumlah",
                        thClass: "text-dark-blue",
                        thStyle: "font-weight: 600",
                        tdClass: "fw-bold",
                        formatter: (value) =>
                          this.$numeral(value).format("$ 0,0.[000]"),
                      },
                      {
                        key: "label",
                        label: "Label",
                        thClass: "text-dark-blue",
                        thStyle: "font-weight: 600",
                        tdClass: "fw-bold",
                      },
                    ];
                  },
                  rowClass() {
                    return "";
                  },
                  profitShare(){
                    let expenses = this.item.sales_reports.filter(({ category }) => category === 'expense')
                    return expenses.find(({ sales_reportable_type }) => sales_reportable_type === 'App\\Models\\BalancingTransaction') || {}
                  }
                },
                methods: {
                  findSaleAdditionalItemByName(name){
                    return this.item.sale_additional_items.find(item => item.name === name) || {}
                  }
                },
                template: /*html*/ `
                  <span>
                    <div class="position-absolute ps-3 w-25" style="left: 18px">
                      <img src="/jala.svg" alt="JALA Logo" class="img-fluid mb-3" style="max-width: 200px">
                      <div class="text-primary fw-light">
                        <p>JALA Office, Ground Floor Sahid J-Walk, Jl. Babarsari No. 2, Janti, Caturtunggal, Depok, Sleman, Daerah Istimewa Yogyakarta, Indonesia 55281</p>
                        <p>Telp: 0274-8000020 (Office)</p>
                      </div>  
                    </div>
                    <b-table-simple hover small caption-top stacked borderless class="bg-gray-100" style="width: 50%;float: right;">
                      <b-tbody class="ps-3">
                        <b-tr>
                          <b-th stacked-heading="Purchased Shrimp" class="text-left border-0 balancing-field">{{$numeral(item.trip.total).format('$ 0,0.[000]')}}</b-th>
                          <b-td stacked-heading="Nota Bongkar" class="balancing-field">{{$numeral(item.total).format('$ 0,0.[000]')}}</b-td>
                          <b-td stacked-heading="Pph" class="balancing-field">{{$numeral(Math.abs(findSaleAdditionalItemByName('PPH 22').total)).format('$ 0,0.[000]')}}</b-td>
                          <b-td stacked-heading="Margin JALA" class="balancing-field">{{$numeral(item.total_service_fee).format('$ 0,0.[000]')}}</b-td>
                          <b-td v-if="isAdmin" stacked-heading="Biaya Akselerasi" class="balancing-field">{{$numeral(Math.abs(findSaleAdditionalItemByName('Biaya Percepatan').total)).format('$ 0,0.[000]')}}</b-td>
                          <b-td stacked-heading="Bagi Hasil" class="balancing-field text-success">{{$numeral(Math.abs(profitShare.total)).format('$ 0,0.[000]')}}</b-td>
                        </b-tr>
                      </b-tbody>
                    </b-table-simple>
                  </span>
                  `,
              },
            },
            {
              key: "BALANCING",
              printable: true,
              class: 'd-none d-print-block',
              item: this.model,
              labelClass: "d-none",
              labelStyles: {
                width: "40%",
              },
              // valueStyles: {
              //   width: "40%",
              // },
              labelItemStyles: {
                fontSize: "1rem",
                color: "white",
                margin: "0",
                fontWeight: "400",
              },
              trClass: "text-right",
              valueClass: 'ms-auto balancing ps-3',
              value: {
                props: {
                  item: {
                    type: Object,
                    default() {
                      return {};
                    },
                  },
                },
                computed: {
                  rowClass() {
                    return "";
                  },
                  profitShare(){
                    let expenses = this.item.sales_reports.filter(({ category }) => category === 'expense')
                    return expenses.find(({ sales_reportable_type }) => sales_reportable_type === 'App\\Models\\BalancingTransaction') || {}
                  },
                  cogs(){
                    return this.item.sales_reports.filter(({category}) => category === 'cost_of_goods_sold')
                  },
                  groupedBySubCategory(){
                    return this.lodash.groupBy(this.cogs, 'sub_category')
                  },
                  ice(){
                    return this.item.sales_reports.find(({sub_category}) => sub_category === 'ice')?.total || 0
                  },
                  labourCost(){
                    return Math.abs(this.item.sales_reports
                            .filter(({sub_category}) => sub_category === 'labour')
                            .reduce((prev, curr) => {
                              return curr.total += prev
                            }, 0))
                  },
                  shippingCost(){
                    return Math.abs(this.item.sales_reports
                            .filter(({sub_category}) => sub_category === 'delivery')
                            .reduce((prev, curr) => {
                              return curr.total += prev
                            }, 0))
                  },
                  total(){
                    return this.ice + this.labourCost + this.shippingCost + Math.abs(this.item.total_profit) + Math.abs(this.profitShare.total)
                  },
                },
                methods: {
                  findSaleAdditionalItemByName(name){
                    return this.item.sale_additional_items.find(item => item.name === name) || {}
                  }
                },
                template: /*html*/ `
                  <b-table-simple hover small caption-top stacked borderless class="bg-gray-100" style="width: 40%;float: right;">
                    <b-tbody class="px-3 border">
                      <b-tr>
                        <b-th stacked-heading="Nota Panen" class="text-left border-0 balancing-field">{{$numeral(item.trip.total).format('$ 0,0.[000]')}}</b-th>
                        <b-td stacked-heading="Pph" class="balancing-field">{{$numeral(Math.abs(findSaleAdditionalItemByName('PPH 22').total)).format('$ 0,0.[000]')}}</b-td>
                        <b-td stacked-heading="Margin JALA" class="balancing-field">{{$numeral(item.total_service_fee).format('$ 0,0.[000]')}}</b-td>
                        <b-td stacked-heading="TRANSFER KE MITRA" class="balancing-field text-success">{{$numeral(total).format('$ 0,0.[000]')}}</b-td>
                      </b-tr>
                    </b-tbody>
                  </b-table-simple>
                  `,
              },
            },
            {
              key: "BALANCING",
              printable: true,
              class: 'd-none d-print-block',
              item: this.model,
              labelClass: "d-none",
              labelStyles: {
                width: "40%",
              },
              // valueStyles: {
              //   width: "40%",
              // },
              labelItemStyles: {
                fontSize: "1rem",
                color: "white",
                margin: "0",
                fontWeight: "400",
              },
              trClass: "text-right",
              valueClass: 'ms-auto balancing ps-3',
              value: {
                props: {
                  item: {
                    type: Object,
                    default() {
                      return {};
                    },
                  },
                },
                computed: {
                  rowClass() {
                    return "";
                  },
                  profitShare(){
                    let expenses = this.item.sales_reports.filter(({ category }) => category === 'expense')
                    return expenses.find(({ sales_reportable_type }) => sales_reportable_type === 'App\\Models\\BalancingTransaction') || {}
                  },
                  cogs(){
                    return this.item.sales_reports.filter(({category}) => category === 'cost_of_goods_sold')
                  },
                  groupedBySubCategory(){
                    return this.lodash.groupBy(this.cogs, 'sub_category')
                  },
                  ice(){
                    return this.item.sales_reports.find(({sub_category}) => sub_category === 'ice')?.total || 0
                  },
                  labourCost(){
                    return Math.abs(this.item.sales_reports
                            .filter(({sub_category}) => sub_category === 'labour')
                            .reduce((prev, curr) => {
                              return curr.total += prev
                            }, 0))
                  },
                  shippingCost(){
                    return Math.abs(this.item.sales_reports
                            .filter(({sub_category}) => sub_category === 'delivery')
                            .reduce((prev, curr) => {
                              return curr.total += prev
                            }, 0))
                  },
                  total(){
                    return this.ice + this.labourCost + this.shippingCost + Math.abs(this.item.total_profit) + Math.abs(this.profitShare.total)
                  },
                },
                methods: {
                  findSaleAdditionalItemByName(name){
                    return this.item.sale_additional_items.find(item => item.name === name) || {}
                  }
                },
                template: /*html*/ `
                  <span>
                    <div class="position-absolute ps-3 w-25" style="left: 18px">
                      
                    </div>
                    <b-table-simple hover small caption-top stacked borderless class="bg-gray-100" style="width: 40%;float: right;">
                      <b-tbody class="px-3 border">
                        <b-tr>
                          <b-td stacked-heading="TRANSFER KE MITRA" class="balancing-field text-success border-0">{{$numeral(total).format('$ 0,0.[000]')}}</b-td>
                          <b-th stacked-heading="Glazing" class="text-left balancing-field">{{$numeral(Math.abs(ice)).format('$ 0,0.[000]')}}</b-th>
                          <b-td stacked-heading="Labour Cost" class="balancing-field">{{$numeral(labourCost).format('$ 0,0.[000]')}}</b-td>
                          <b-td stacked-heading="Shipping Cost" class="balancing-field">{{$numeral(Math.abs(item.total_profit)).format('$ 0,0.[000]')}}</b-td>
                          <b-td stacked-heading="Bagi Hasil" class="balancing-field">{{$numeral(Math.abs(profitShare.total)).format('$ 0,0.[000]')}}</b-td>
                        </b-tr>
                      </b-tbody>
                    </b-table-simple>
                  </span>
                  `,
              },
            },
          ]
    },
    brsModelMapped(role = 'ADMIN'){
      if(role)
      return [
      {
              key: `NOTA PANEN`,
              class: 'd-block d-print-none',
              item: this.model,
              labelItemStyles: {
                fontWeight: "600",
              },
              labelItemClass: "text-dark-blue",
              valueClass: 'bg-white border p-3',
              tdClass: 'this-is-td',
              rowClass: 'row-class',
              value: {
                props: {
                  item: {
                    type: Object,
                    default() {
                      return {};
                    },
                  },
                  role: {
                    type: String,
                    default: 'ADMIN',
                  },
                },
                computed: {
                  fields() {
                    return [
                      // index
                      { 
                        key: 'index', 
                        label: 'No', 
                        sortable: false, 
                        style: { width: '1%' },
                        thStyle: "font-weight: 600; background: #F9FAFB",
                      },
                      {
                        key: "quantity",
                        label: "Biomassa (kg)",
                        thStyle: "font-weight: 600; background: #F9FAFB",
                        tdClass: "fw-bold",
                      },
                      {
                        key: "size",
                        label: "Size",
                        thStyle: "font-weight: 600; background: #F9FAFB",
                        tdClass: "fw-bold",
                      },
                      {
                        key: "unit_price",
                        label: "Harga (/kg)",
                        thStyle: "font-weight: 600; background: #F9FAFB",
                        tdClass: "fw-bold",
                        formatter: (value) =>
                          this.$numeral(value).format("$ 0,0.[000]"),
                      },
                      {
                        key: "total_price",
                        label: "Jumlah",
                        thStyle: "font-weight: 600; background: #F9FAFB",
                        tdClass: "fw-bold",
                        formatter: (value) =>
                          this.$numeral(value).format("$ 0,0.[000]"),
                      },
                    ];
                  },
                  rowClass() {
                    return "";
                  },
                  totalBiomassa() {
                    return this.$numeral(
                      this.item.sale_item_total_quantity
                    ).format("0,0.[000]");
                  },
                  total(){
                    return this.$numeral(
                      this.item.total
                    ).format("$ 0,0.[000]");
                  },
                  metaFields(){
                    return [
                      { 
                        key: 'Tanggal',
                        value: this.$moment(this.item.purchase_order.ordered_at).format('DD MMMM YYYY'),
                        class: 'row',
                        labelClass: 'col-sm-12 col-md-4',
                        valueClass: 'col-sm-12 col-md-8',
                        showColon: true,
                        tdClass: 'p-0'
                      },
                      { 
                        key: 'Mitra',
                        value: this.item?.purchase_order?.customer?.name || '-',
                        class: 'row',
                        labelClass: 'col-sm-12 col-md-4',
                        valueClass: 'col-sm-12 col-md-8',
                        showColon: true,
                      },
                      {
                        key: this.lodash.upperFirst(this.$t('products.singular')),
                        value: this.item?.sale_items[0]?.purchase_item?.purchase_order?.product?.name || '-',
                        class: 'row',
                        labelItemClass: 'text-dark-blue',
                        labelClass: 'col-sm-12 col-md-4',
                        valueClass: 'col-sm-12 col-md-8',
                        showColon: true,
                        _denyShow: role === 'MITRA'
                      },
                    ].filter((field) => !field._denyShow);
                  },
                  columns() {
                    return {
                      ["model"]: [
                        {
                          key: "key",
                          label: this.$t("models.key"),
                          component: Row,
                        },
                      ],
                    };
                  },
                },
                template: /*html*/ `
                    <div>
                      <div class="row">
                        <div class="col-md-4">
                          <b-table
                            :items="metaFields.slice(0, 3)"
                            :fields="columns['model']"
                            show-empty
                            :responsive="true"
                            thead-class="d-none"
                            borderless
                            tbody-tr-class="mapped-field-row"
                          >
                            <template #cell()="data">
                              <template v-if="data.field.component">
                                <component :is="data.field.component" v-bind="{item: data.item}" v-on="data.field['componentListeners'] || {}"></component>
                              </template>
                              <template v-else>{{ data.value }}</template>
                            </template>
                          </b-table>
                        </div>
                        <div class="col-md-4" v-if="metaFields.slice(3, 6).length">
                          <b-table
                            :items="metaFields.slice(3, 6)"
                            :fields="columns['model']"
                            show-empty
                            :responsive="true"
                            thead-class="d-none"
                            borderless
                            tbody-tr-class="mapped-field-row"
                          >
                            <template #cell()="data">
                              <template v-if="data.field.component">
                                <component :is="data.field.component" v-bind="{item: data.item}" v-on="data.field['componentListeners'] || {}"></component>
                              </template>
                              <template v-else>{{ data.value }}</template>
                            </template>
                          </b-table>
                        </div>
                      </div>
                      <b-table v-if="item.sale_items" :tbody-tr-class="rowClass" :fields="fields" :items="item.sale_items" borderless outlined class="mt-3">
                        <template v-slot:custom-foot="data">
                          <b-tr style="background: #F9FAFB">
                            <b-td class="text-left text-success" style="fontWeight: 600 !important" ></b-td>
                            <b-td class="text-left text-success" style="fontWeight: 600 !important" >{{totalBiomassa}}</b-td>
                            <b-td class="text-left text-success" style="fontWeight: 600 !important" ></b-td>
                            <b-td class="text-left text-success" style="fontWeight: 600 !important" ></b-td>
                            <b-td class="text-left text-success" style="fontWeight: 600 !important" >{{total}}</b-td>
                          </b-tr>
                        </template>
                      </b-table>
                    </div>
                  `,
              },
              thStyle: "display: none",
              isRowHeader: true,
            },
            // PRINT VIEW
            {
              key: 'JALA Logo',
              labelClass: 'd-none',
              valueClass: 'text-center',
              class: 'd-none d-print-block',
              value: {
                template: /*html*/ `
                  <img src="/jala.svg" alt="JALA Logo" class="img-fluid" style="max-width: 200px">
                `
              }
            },
            {
              printable: true,
              class: 'd-none d-print-block',
              key: `Nota Panen`,
              label: {
                template: /*html*/`
                  <div class="custom-label bg-primary text-white p-3 py-2 gap-3 align-items-center" style="display: flex;">
                    <router-link :to="'/purchase_orders/${this.model.purchase_order.id}'">
                      <h6 class="label-item border border-top-0 border-start-0 border-end-0" style="font-size: 1rem; color: white; margin: 0px; font-weight: 400;">
                        Nota Panen
                      </h6>
                    </router-link>
                    <div style="font-size: 1rem; color: white; margin: 0px; font-weight: 400;">${this.$moment.utc(this.model.purchase_order.ordered_at).local().format('DD MMM YYYY')}</div>
                  </div>
                `
              },
              // class: 'd-none d-print-block',
              item: this.model.sale_items,
              labelClass: "bg-primary text-white p-3 ",
              labelItemStyles: {
                fontSize: "1rem",
                color: "white",
                margin: "0",
                fontWeight: "400",
              },
              valueClass: 'bg-gray-100 px-2 border',
              value: {
                props: {
                  item: {
                    type: Array,
                    default() {
                      return [];
                    },
                  },
                },
                computed: {
                  fields() {
                    return [
                      // index
                      { key: 'index', label: 'No', sortable: false, style: { width: '1%' } },
                      {
                        key: "quantity",
                        label: "Biomassa",
                        sortable: false,
                        style: { width: "1%" },
                        thClass: "text-dark-blue",
                        thStyle: "font-weight: 600",
                        tdClass: "fw-bold",
                      },
                      {
                        key: "size",
                        label: "Size",
                        sortable: false,
                        style: { width: "1%" },
                        thClass: "text-dark-blue",
                        thStyle: "font-weight: 600",
                        tdClass: "fw-bold",
                      },
                      {
                        key: "unit_price",
                        label: "Harga",
                        thClass: "text-dark-blue",
                        thStyle: "font-weight: 600",
                        tdClass: "fw-bold",
                        formatter: (value) =>
                          this.$numeral(value).format("$ 0,0.[000]"),
                      },
                      {
                        key: "total_price",
                        label: "Jumlah",
                        thClass: "text-dark-blue",
                        thStyle: "font-weight: 600",
                        tdClass: "fw-bold",
                        formatter: (value) =>
                          this.$numeral(value).format("$ 0,0.[000]"),
                      },

                    ];
                  },
                  rowClass() {
                    return "";
                  },
                  totalBiomassa() {
                    return this.$numeral(
                      this.item.reduce((acc, cur) => acc + cur.quantity, 0)
                    ).format("0,0.[000]");
                  },
                  total(){
                    return this.$numeral(
                      this.item.reduce((acc, cur) => acc + cur.total_price, 0)
                    ).format("$ 0,0.[000]");
                  }
                },
                template: /*html*/ `
                    <b-table :tbody-tr-class="rowClass" :fields="fields" :items="item" borderless>
                      <template v-slot:custom-foot="data">
                        <b-tr>
                          <b-td class="text-left text-success" style="fontWeight: 600 !important" ></b-td>
                          <b-td class="text-left text-success" style="fontWeight: 600 !important" ></b-td>
                          <b-td class="text-left text-success" style="fontWeight: 600 !important" ></b-td>
                          <b-td class="text-left text-success" style="fontWeight: 600 !important" >{{totalBiomassa}}</b-td>
                          <b-td class="text-left text-success" style="fontWeight: 600 !important" >{{total}}</b-td>
                        </b-tr>
                      </template>
                    </b-table>
                  `,
              },
            },
            {
              printable: true,
              class: 'd-none d-print-block',
              key: `Penerimaan Penjualan`,
              label: {
                template: /*html*/`
                  <div class="custom-label bg-primary text-white p-3 py-2 gap-3 align-items-center" style="display: flex;">
                    <router-link :to="'/sale_invoices/${this.model.id}'">
                      <h6 class="label-item border border-top-0 border-start-0 border-end-0" style="font-size: 1rem; color: white; margin: 0px; font-weight: 400;">
                        Penerimaan Penjualan
                      </h6>
                    </router-link>
                    <div style="font-size: 1rem; color: white; margin: 0px; font-weight: 400;">${this.$moment.utc(this.model.purchase_order.ordered_at).local().format('DD MMM YYYY')}</div>
                  </div>
                `
              },
              // class: 'd-none d-print-block',
              item: this.model.payments,
              labelClass: "bg-primary text-white p-3 ",
              labelItemStyles: {
                fontSize: "1rem",
                color: "white",
                margin: "0",
                fontWeight: "400",
              },
              valueClass: 'bg-gray-100 px-2 border',
              value: {
                props: {
                  item: {
                    type: Array,
                    default() {
                      return [];
                    },
                  },
                },
                computed: {
                  fields() {
                    return [
                      // index
                      { key: 'invoice_number', label: 'No.Penjualan', sortable: false, style: { width: '1%' } },
                      {
                        key: "paid_at",
                        label: "Tanggal",
                        sortable: false,
                        style: { width: "1%" },
                        thClass: "text-dark-blue",
                        thStyle: "font-weight: 600",
                        tdClass: "fw-bold",
                      },
                      {
                        key: "nominal",
                        label: "Nominal",
                        sortable: false,
                        style: { width: "1%" },
                        thClass: "text-dark-blue",
                        thStyle: "font-weight: 600",
                        tdClass: "fw-bold",
                        formatter: (value) =>
                          this.$numeral(value).format("$ 0,0.[000]"),
                      },
                      {
                        key: "from_bank_account",
                        label: "Pengirim",
                        sortable: false,
                        style: { width: "1%" },
                        thClass: "text-dark-blue",
                        thStyle: "font-weight: 600",
                        tdClass: "fw-bold",
                        formatter: (value) => `${this.lodash.startCase(value.customer.name)} - ${value.account_number} - ${value.bank.name}`
                      },
                      {
                        key: "to_bank_account",
                        label: "Penerima",
                        sortable: false,
                        style: { width: "1%" },
                        thClass: "text-dark-blue",
                        thStyle: "font-weight: 600",
                        tdClass: "fw-bold",
                        formatter: (value) => `${this.lodash.startCase(value.customer.name)} - ${value.account_number} - ${value.bank.name}`
                      },
                    ];
                  },
                  rowClass() {
                    return "";
                  },
                  totalBiomassa() {
                    return this.$numeral(
                      this.item.reduce((acc, cur) => acc + cur.quantity, 0)
                    ).format("0,0.[000]");
                  },
                  total(){
                    return this.$numeral(
                      this.item.reduce((acc, cur) => acc + cur.total_price, 0)
                    ).format("$ 0,0.[000]");
                  }
                },
                template: /*html*/ `
                    <b-table :tbody-tr-class="rowClass" :fields="fields" :items="item" borderless>
                      
                    </b-table>
                  `,
              },
            },
            {
              key: "Total",
              class: 'd-none d-print-block',
              item: this.model,
              labelClass: "bg-primary text-white p-3 ms-auto",
              labelStyles: {
                width: "50%",
              },
              // valueStyles: {
              //   width: "50%",
              // },
              labelItemStyles: {
                fontSize: "1rem",
                color: "white",
                margin: "0",
                fontWeight: "400",
              },
              trClass: "text-right",
              valueClass: 'ms-auto',
              value: {
                props: {
                  item: {
                    type: Object,
                    default() {
                      return {};
                    },
                  },
                },
                computed: {
                  isAdmin(){
                    return role === 'admin'
                  },
                  rowClass() {
                    return "";
                  },
                  profitShare(){
                    let expenses = this.item.sales_reports.filter(({ category }) => category === 'expense')
                    return expenses.find(({ sales_reportable_type }) => sales_reportable_type === 'App\\Models\\BalancingTransaction') || {}
                  }
                },
                methods: {
                  findSaleAdditionalItemByName(name){
                    return this.item.sale_additional_items.find(item => item.name === name) || {}
                  }
                },
                template: /*html*/ `
                  <span>
                    <div class="position-absolute ps-3 w-25" style="left: 18px">
                      <img src="/jala.svg" alt="JALA Logo" class="img-fluid mb-3" style="max-width: 200px">
                      <div class="text-primary fw-light">
                        <p>JALA Office, Ground Floor Sahid J-Walk, Jl. Babarsari No. 2, Janti, Caturtunggal, Depok, Sleman, Daerah Istimewa Yogyakarta, Indonesia 55281</p>
                        <p>Telp: 0274-8000020 (Office)</p>
                      </div>  
                    </div>
                    <b-table-simple hover small caption-top stacked borderless class="bg-gray-100" style="width: 50%;float: right;">
                      <b-tbody class="ps-3">
                        <b-tr>
                          <b-th stacked-heading="Purchased Shrimp" class="text-left border-0 balancing-field">{{$numeral(item.total).format('$ 0,0.[000]')}}</b-th>
                          <b-td stacked-heading="Penjualan" class="balancing-field">{{$numeral(item.sale_payment_total).format('$ 0,0.[000]')}}</b-td>
                          <b-td stacked-heading="Margin JALA" class="balancing-field">{{$numeral(item.total_service_fee).format('$ 0,0.[000]')}}</b-td>
                        </b-tr>
                      </b-tbody>
                    </b-table-simple>
                  </span>
                  `,
              },
            },
      ];
    },
    pills(){
      return [
        {
          label: 'Detail',
          active: (this.$route.name === 'sale_notes.show'),
          onClick: () => this.$router.push({ name: 'sale_notes.show', params: { key: this.$route.params.key, model: this.model } })
        },
        // {
        //   label: 'Balancing',
        //   active: (this.$route.name === 'sale_notes.balancing'),
        //   onClick: () => this.$router.push({ name: 'sale_notes.balancing', params: { key: this.$route.params.key, model: this.model } })
        // },
        {
          label: 'Resume',
          active: (this.$route.name === 'sale_notes.resume'),
          onClick: () => this.$router.push({ name: 'sale_notes.resume', params: { key: this.$route.params.key, model: this.model } })
        },
      ]
    },
    delete() {
      return this.$axios.delete(`/sale_orders/${this.$route.params.key}`);
    },
    fetchModel() {
      // if model in params
      // if (this.$route.params.model) {
      //   this.model = this.$route.params.model;
      //   this.loading = false;
      //   return;
      // }
      this.loading = true;
      return this.$axios
        .get(`/sale_orders/${this.$route.params.key}`, {
          params: {
            with: [
              "creator",
              "customer",
              "purchase_order.customer",
              "purchase_order.product",
              "sale_additional_items",
              "sale_items.purchase_order.customer",
              'sale_items.purchase_order.product',
              "sale_items.purchase_item.purchase_order.customer",
              "sale_items.purchase_item.purchase_order.product",
              "sale_items.trip_item.purchase_item",
              "sale_items.trip_item.purchase_order.customer",
              "sale_items.trip_item.purchase_order.product",
              "trip.customer",
              "ticket",
              "trip.trip_items.purchase_item",
              "trip.delivery_order.customer",
              "trip.vehicle",
              "trip.driver",
              "trip.unload.sale_items.trip_item.purchase_item",
              "trip.unload.sale_items.product",
              "sales_reports.sales_reportable",
              "operational_costs",
              "payments.from_bank_account",
              "payments.from_bank_account.bank",
              "payments.from_bank_account.customer",
              "payments.to_bank_account",
              "payments.to_bank_account.bank",
              "payments.to_bank_account.customer",
            ].join(","),
          },
        })
        .then((response) => {
          const {
            data: { data },
          } = response;
          this.model = {
            ...this.modifyModelResponse(data),
            additional_fees: data.sale_additional_items.filter(
              (item) => item.total > 0
            ),
            discounts: data.sale_additional_items.filter(
              (item) => item.total < 0
            ),
          };
          return response;
        })
        .catch((error) => this.failedAlert(error))
        .finally(() => (this.loading = false));
    },
    modifyModelResponse(saleOrder) {
      let model = saleOrder;
      const trip_item_ids = [];
      if(model.trip){
        model.trip.trip_items = model.trip.trip_items.map((item, index) => ({...item, index: index + 1}))
      }
      if(model.sale_items){
        model.sale_items = model.sale_items.map((item, index) => ({...item, index: index + 1}))
      }
      if(model.trip?.unload?.sale_items){
        model.trip.unload.sale_items = model.trip?.unload.sale_items.map((item) => {
            // item.size_performance =
            //   ((item.initial_size - item.size) /
            //     item.initial_size) *
            //   100;
            if (!trip_item_ids.includes(item.trip_item_id)) {
              trip_item_ids.push(item.trip_item_id);
              item._index = trip_item_ids.length;
              if(item._index){
                item.rowspan = model.trip.unload.sale_items.filter(
                  (sale_item) => sale_item.trip_item_id === item.trip_item_id
                ).length;
              }
              item.estimated_size =
                item.initial_size * 0.9;
              item.estimated_quantity =
                item.initial_quantity * 1.12;
              // const totalQuantity = model.trip?.unload.sale_items
              //   .filter(
              //     (sale_item) => sale_item.trip_item_id === item.trip_item_id
              //   )
              //   .reduce((acc, cur) => acc + cur.quantity, 0);
              // item.quantity_performance =
              //   ((totalQuantity - item.initial_quantity) /
              //     item.initial_quantity) *
              //   100;
            } else {
              item.trip_item_id = null;
              item.product = null;
              item.trip_item = null;
              item.quantity_performance = null;
            }
            return item;
          });
      //   if (saleOrder.ticket.customer_type === 'brs') {
      //     model = this.brsSaleOrderModel(saleOrder)
      //   } else {
      //     if (saleOrder.type === 'unload') {
      //       model = this.processingSaleOrderModel(saleOrder)
      //     } else if(saleOrder.type === 'local_market') {
      //       model = this.localMarketSaleOrderModel(saleOrder)
      //     }
      //   }  
      }
      
      return model;
    },
  },
};
</script>

<style scoped lang="scss">
  ::v-deep .balancing-field::before {
    text-align: left !important;
  }
  ::v-deep .balancing-field {
    font-weight: bold;
  }

  * {
    font-family: 'Lato', sans-serif;
    color: #161B4D ;
  }

  ::v-deep .custom-value > * {
    color: #161B4D !important;
  }
  ::v-deep td, ::v-deep .custom-value > *, ::v-deep th {
    color: #161B4D;
  }
  ::v-deep .page-content {
    background: #EEF3F7;
  }

  @page {
    size: A4;
  }

  @media print {
    ::v-deep .page-content {
      background: #fff;
      -webkit-print-color-adjust: exact !important;
      color-adjust: exact !important;
      print-color-adjust: exact !important;
    }

    ::v-deep .label-with-date::after {
      content: var(--date);
    }

    ::v-deep * {
      overflow: hidden;
    }
  }
  
  ::v-deep .mapped-field-row > td {
    padding-block: 0 !important;
    padding-left: 0 !important;
  }

  ::v-deep .card-body {
    padding: 30px 0px;
    /* & > */
  }

  ::v-deep .main-table > td {
    padding-inline: 0;
  }

  ::v-deep {
    .role-tabs {
      width: fit-content;
    }

    .partner-transfer::before{
        padding-left: 14px !important;
    }

    .sub-tabs {
      .nav-tabs {
        width: 300px !important;
        // margin-right: -600px;
      }
    }
  }
</style>